// extracted by mini-css-extract-plugin
export var list = "benefit-list-module--list--+VYU3";
export var item = "benefit-list-module--item--pUMkK";